import { enIN } from 'date-fns/locale';
import { Field, Formik, Form as FormikForm } from 'formik';
import React, { useEffect, useState } from 'react';
import { Button, Col, Dropdown, Form, Row } from 'react-bootstrap';
import { registerLocale } from 'react-datepicker';
import { EventsOptions } from '../../../constants/options.constant';
import validCharacters from '../../../constants/valid-characters';
import { UserLogsFilterInitialState } from '../../../core/initialState/filter-initial-state';
import FormikFormInput from '../../../shared-components/FormikFormHandlers/FormikFormInput';
import FormikFormSelect from '../../../shared-components/FormikFormHandlers/FormikFormSelect';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import {
  ClearFilterIcon,
  FilterIcon,
} from '../../../shared-components/svgs/svgs';
import { formatMessage } from '../../../translations/format-message';
import FormikFormDatePicker from '../../../shared-components/FormikFormHandlers/FormikFormDatePicker';
import { FilterValidationSchema } from '../../../shared-components/FormikFormHandlers/FormikValidationSchema';
import { IUserLogsFilter } from '../../../models/IUserLogsFilter';
import {
  getTenantIdFromLocalStorage,
  getUserType,
} from '../../../helpers/localstorage-helper';
import { IOption } from '../../../models/ICommon';

registerLocale('en-IN', enIN);

interface IProps {
  initialValues: any;
  id: number;
  submitHandler: (data: any) => void;
  filterParmas: (data: any, isfilterCleard: boolean) => void;
  onModalClosed: () => void;
  isLoading: boolean;
  isDisable: boolean;
  isFilterCleared: boolean;
  isFilterApplied: boolean;
  setIsFilterApplied: (status: boolean) => void;
  tenantBlankOptions: IOption[];
  moduleOptions: IOption[];
}
const FilterComponent = (props: IProps) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const handleToggle = (isOpen: boolean, resetForm: () => void) => {
    if (!isOpen) {
      resetForm();
    }
    setShowDropdown(isOpen);
  };

  function getLocalISODate(isoDate: Date) {
    return (
      isoDate.getFullYear() +
      '-' +
      String(isoDate.getMonth() + 1).padStart(2, '0') +
      '-' +
      String(isoDate.getDate()).padStart(2, '0') +
      'T' +
      String(isoDate.getHours()).padStart(2, '0') +
      ':' +
      String(isoDate.getMinutes()).padStart(2, '0') +
      ':' +
      String(isoDate.getSeconds()).padStart(2, '0')
    );
  }

  const currentUserType = getUserType();
  // const moduleOptions = React.useMemo(() => {
  //   if (
  //     currentUserType === 'FactoryAdmin' ||
  //     currentUserType === 'FactoryManager'
  //   ) {
  //     return ModuleOptions.filter(
  //       (option) =>
  //         option.id === -1 ||
  //         (option.value !== 'TenantManagement' &&
  //           option.value !== 'ProcessManagement')
  //     );
  //   }

  //   return ModuleOptions;
  // }, [currentUserType]);

  return (
    <React.Fragment>
      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validationSchema={FilterValidationSchema}
        validateOnBlur={false}
        onSubmit={async (
          values: IUserLogsFilter,
          { resetForm, setFieldValue }
        ) => {
          // console.log('values', values);
          if (values.StartDate) {
            values = {
              ...values,
              StartDate: `${getLocalISODate(new Date(values.StartDate)).slice(0, 10)}`,
            };
          }
          if (values.EndDate) {
            values = {
              ...values,
              EndDate: `${getLocalISODate(new Date(values.EndDate)).slice(0, 10)}`,
            };
          }
          const selectedFactory = props.tenantBlankOptions.find(
            (opt) => opt.id === Number(values.Factory)
          );
          props.submitHandler({
            ...values,
            Factory: selectedFactory.id === -1 ? '' : selectedFactory.value,
            Action: values.Action === '-1' ? '' : values.Action,
          });
          setShowDropdown(false);
          props.setIsFilterApplied(true);
        }}
      >
        {({ dirty, resetForm, setFieldValue, values }) => {
          const factoryVal =
            values.Factory && typeof values.Factory === 'object'
              ? (values.Factory as any).id
              : values.Factory;

          const isFactorySelected =
            factoryVal !== undefined &&
            factoryVal !== null &&
            factoryVal !== '' &&
            Number(factoryVal) !== -1;

          const isSameExcludingEndDate =
            JSON.stringify({ ...props.initialValues, EndDate: null }) ===
            JSON.stringify({ ...values, EndDate: null });


          // useEffect(() => {
          //   if (
          //     isFactorySelected &&
          //     (Number(values.Module) === 0 || Number(values.Module) === 2)
          //   ) {
          //     setFieldValue('Module', -1);
          //   }
          // }, [isFactorySelected, values.Module, setFieldValue]);

          return (
            <Dropdown
              className={`Filter-DID ${props.isDisable ? 'disabled-li' : ''}`}
              show={showDropdown}
              onToggle={(isOpen) => handleToggle(isOpen, resetForm)}
              // autoClose={false}
            >
              <Dropdown.Toggle
                className={`btn btn-light ${props.isFilterApplied ? 'btn-filter-disable' : 'btn-filter'}`}
                aria-expanded="false"
                title={formatMessage('filter')}
              >
                {/* <FilterIcon /> */}
                {!props.isFilterApplied ? (
                  <FilterIcon isDisable={props.isDisable} />
                ) : (
                  <ClearFilterIcon
                    onClick={(e) => {
                      // props.filterParmas(
                      //   { ...UserLogsFilterInitialState },
                      //   true
                      // );
                      resetForm();
                      setShowDropdown(!showDropdown);
                      // props.setIsFilterApplied(!props.isFilterApplied);
                    }}
                  />
                )}
              </Dropdown.Toggle>
              <FormikForm className="user-form">
                {props.isLoading ? (
                  <FormLoader loading={props.isLoading} />
                ) : null}
                <Dropdown.Menu className="filter-menu">
                  <Dropdown.ItemText className="p-0">
                    <Form.Group controlId="dateRange">
                      <div
                        className={`filter-header border-bottom p-3 px-4 ${props.isFilterCleared ? '' : ''}`}
                      >
                        <h4>
                          {formatMessage('filter')}
                          <a
                            className="clear-filter float-end"
                            onClick={() => {
                              resetForm();
                              setShowDropdown(false);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              className="bi bi-x"
                              viewBox="0 0 16 16"
                            >
                              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
                            </svg>
                          </a>
                        </h4>
                      </div>
                      <Row className="p-3 px-4">
                        {/* {getTenantIdFromLocalStorage() === '-1' && (
                        <Col md={6}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="factory_name"
                              htmlFor="Factory"
                            />
                            <Field
                              data-testid="Factory"
                              className="form-control"
                              name="Factory"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validCharacters}
                            />
                          </div>
                        </Col>
                        )} */}
                        <Col md={6}>
                          <div className="form-group">
                            <Label
                              className="label-style col-form-label"
                              // required={!toggleFactoryField}
                              label="factory"
                            />
                            <Field
                              name="Factory"
                              as={FormikFormSelect}
                              disabled={getTenantIdFromLocalStorage() !== '-1'}
                              options={props.tenantBlankOptions}
                              className="form-control"
                              // setDefaultValue={true}
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="user_name"
                              htmlFor="UserName"
                            />

                            <Field
                              data-testid="UserName"
                              className="form-control"
                              name="UserName"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validCharacters}
                            />
                            {/* <Field
                              name="UserName"
                              as={FormikFormSelect}
                              options={UserTypeOptions}
                              data-testid="UserName"
                              className="form-control"
                              validcharacter={validCharacters}
                            /> */}
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="event"
                              htmlFor="Action"
                            />

                            <Field
                              name="Action"
                              as={FormikFormSelect}
                              options={EventsOptions}
                              data-testid="Action"
                              className="form-control"
                              validcharacter={validCharacters}
                              //getData={true}
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="key_field"
                            />
                            <Field
                              data-testid="ActionDetail"
                              className="form-control"
                              name="ActionDetail"
                              autoComplete="off"
                              type="text"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validCharacters}
                            />
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="module"
                            />
                            <Field
                              data-testid="Module"
                              className="form-control"
                              name="Module"
                              autoComplete="off"
                              type="text"
                              placeholder=""
                              as={FormikFormSelect}
                              options={props.moduleOptions}
                              validcharacter={validCharacters}
                              onChange={(
                                e: React.ChangeEvent<HTMLSelectElement>
                              ) =>
                                setFieldValue('Module', Number(e.target.value))
                              }
                            />
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="start_date"
                              htmlFor="StartDate"
                            />
                            <Field
                              data-testid="StartDate"
                              className="form-control"
                              name="StartDate"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormDatePicker}
                              isClearable={values.StartDate}
                              maxDate={values.EndDate ? new Date(values.EndDate) : undefined}
                              //validcharacter={validCharacters}
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="end_date"
                              htmlFor="EndDate"
                            />
                            <Field
                              data-testid="EndDate"
                              className="form-control"
                              name="EndDate"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormDatePicker}
                              isClearable={values.EndDate}
                              minDate={values.StartDate ? new Date(values.StartDate) : undefined}
                              //validcharacter={validCharacters}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form.Group>
                  </Dropdown.ItemText>
                  <Dropdown.Divider className="mb-0" />
                  <div className="d-flex filter-btn p-3 px-4 justify-content-between align-items-center">
                    <div
                      style={{
                        visibility: props.isFilterCleared
                          ? 'hidden'
                          : 'visible',
                      }}
                    >
                      <Button
                        className="clear-filter float-end"
                        onClick={() => {
                          props.filterParmas(UserLogsFilterInitialState, true);
                          resetForm();
                          setShowDropdown(false);
                          props.setIsFilterApplied(false);
                        }}
                      >
                        {formatMessage('clear_all_filters')}
                      </Button>
                    </div>
                    <Button
                      variant="secondary"
                      type="submit"
                      className=""
                      disabled={
                        !dirty ||
                        JSON.stringify(props.initialValues) ===
                          JSON.stringify(values) ||
                        (!values.UserName &&
                          !values.Action &&
                          !values.ActionDetail &&
                          (values.Factory === '-1' || !values.Factory) &&
                          (!values.Module || values.Module === -1) &&
                          !values.StartDate &&
                          (!values.EndDate || values.EndDate === null)) ||
                        (isSameExcludingEndDate && !values.EndDate)
                      }
                    >
                      {formatMessage('apply')}
                    </Button>
                  </div>
                </Dropdown.Menu>
              </FormikForm>
            </Dropdown>
          );
        }}
      </Formik>
    </React.Fragment>
  );
};

export default FilterComponent;
